export default "__VITE_ASSET__Ca93ypth__"